import { render, staticRenderFns } from "./trimEditor.vue?vue&type=template&id=52fd2266&"
import script from "./trimEditor.vue?vue&type=script&lang=ts&"
export * from "./trimEditor.vue?vue&type=script&lang=ts&"
import style0 from "./trimEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports